import React, { useEffect, useState, useRef } from "react";
import { Outlet, Route, Routes, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import LeftMenu from "../components/LeftMenu";
import CompanySetUp from "../Screens/HubExperience/CompanySetup";
import MedicalCredentials from "../Screens/HubExperience/MedicalCredentials";
import MedicalPlanSetup from "../Screens/HubExperience/MedicalPlanSetup";
import theme from "../Utils/theme";
import ServiceRequest from "../Screens/ServiceRequest";
import Leftdrawer from "../components/common/Drawer/LeftDrawer";
import RightDrawer from "../components/common/Drawer/RightDrawer";
import VisionPlanSetup from "../Screens/HubExperience/VisionPlanSetUp";
import DentalPlanSetup from "../Screens/HubExperience/DentalPlanSetUp";
import ImportCarrierFile from "../Screens/HubExperience/ImportCarrierFile";
import ApproveCarrierFile from "../Screens/HubExperience/ApproveCarrierFile";
import Dashboard from "../Screens/ACGHealthInsights/Dashboard";
import { LeftMenuData } from "../Utils/constants";
import RebatesAndReimbursements from "../Screens/HubExperience/RebatesAndReimbursements";
import SBARForm from "../Screens/ClinicalIntake/SBARForm";
import SBARFormRequest from "../Screens/ServiceRequest/SBARFormRequest";
import MarketScanManagement from "../Screens/ServiceRequest/MarketScanManagement";
import Sisense from "../Screens/Sisense(SSO)";
import EmpoweRX from "../Screens/EmpoweRx/CreateRFP";
import EmpoweRxRequest from "../Screens/ServiceRequest/EmpoweRxRequest";
import Resource from "../Screens/ResourceCenter";
import PlanInsights from "../Screens/PlanInsights";
import SpecialtyDrugList from "../Screens/EmpoweRx/SpecialtyDrugList";
import ClientRxInformation from "../Screens/EmpoweRx/ClientRxInformation";
import SBARFormReview from "../Screens/ClinicalIntake/SBARFormReview";
import ListOfCDTGroup from "../Screens/CedarGateGroup/listOfGroup";
import Epocrates from "../Screens/Clinical Consulting/Epocrates";
import UpToDate from "../Screens/Clinical Consulting/UpToDate";
import MDPathways from "../Screens/Clinical Consulting/MD Pathways";
import SBARFormIntakeRequest from "../Screens/ServiceRequest/SBARFormIntakeRequest";
import SBARIntakeRequest from "../Screens/ClinicalIntake/SBARIntakeRequest";
import { useSelector } from "react-redux";
import NewRequest from "../Screens/ServiceRequest/ClinicalSupport";
import ClinicalSupport from "../Screens/ServiceRequest/ClinicalSupport";
import RxBlockPricingEx from "../Screens/EmpoweRx/RxBlockPricingEx";
import ReviewBlockPricing from "../Screens/EmpoweRx/ReviewBlockPricing";
import OpenUpdatePeriod from "../Screens/EmpoweRx/OpenUpdatePeriod";
import PowerBI from "../Screens/PowerBI";

const Layout = ({ navigate }) => {
  const user = useSelector((state) => state.userDetails.value);
  const [show, setShow] = useState(false);
  const location = useLocation();

  // const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [open, setOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [leftMenu, setLeftMenu] = useState();
  const navRef = useRef(null);

  useEffect(() => {
    setLeftMenu(LeftMenuData(location,user));
  }, [location.pathname]);

  return (
    <div
      className="vh-100"
      style={{ backgroundColor: theme.PRIMARY_ARCTIC_GRAY }}
    >
      <Header
        handleShow={handleShow}
        leftMenuIspen={open}
        setLeftMenuIsOpen={setOpen}
        rightMenuIspen={isOpen}
        setRightMenuIsOpen={setIsOpen}
        navigate={navigate}
        navRef={navRef}
      />
      <main className="d-flex pe-md-4 pe-0" style={{ height: "80vh" }}>
        <RightDrawer
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          navigate={navigate}
        />
        <Routes>
          <Route path="/sisense" element={<Sisense />} />
          <Route path="/powerbi" element={<PowerBI />} />
          <Route path="/resourcecenter" element={<Resource />} />
          <Route path="/Epocrates" element={<Epocrates />} />
          <Route path="/UpToDate" element={<UpToDate />} />
          <Route path="/MDPathways" element={<MDPathways />} />
          {/* <Route path="/planinsight" element={<PlanInsights />} /> */}
          <Route
            path="/*"
            element={
              <>
                <div className="card sidebar me-4 rounded-0 border-0 overflow-auto pt-3 d-none d-lg-flex">
                  {/* <Drawer show={show} setShow={setShow} handleClose={handleClose} handleShow={handleShow} /> */}
                  <div
                    className="fw-bold text-nowrap lh-lg"
                    style={{ color: theme.SECONDARY_SHOCKING_BLUE }}
                  >
                    <LeftMenu data={leftMenu} />
                  </div>
                </div>
                <Leftdrawer
                  open={open}
                  setOpen={setOpen}
                  data={leftMenu}
                  marginTop={navRef.current?.getBoundingClientRect().bottom}
                />

                {/* </div> */}
                <div className="card overflow-auto w-100 p-md-4 p-2 rounded-0 border-0">
                  <Routes>
                    {location.pathname.match("HUBExperience") ? (
                      <>
                        <Route
                          index
                          element={<CompanySetUp navigate={navigate} />}
                        />
                        <Route
                          path="/companysetup"
                          element={<CompanySetUp navigate={navigate} />}
                        />
                        <Route
                          path="/medicalplansetup"
                          element={<MedicalPlanSetup navigate={navigate} />}
                        />
                        <Route
                          path="/medicalcredentials"
                          element={<MedicalCredentials navigate={navigate} />}
                        />
                        <Route
                          path="/approvecarrierfile/*"
                          element={
                            <ApproveCarrierFile navigate={navigate}>
                              {/* <Route
                        path={`/approvedfile/:id`}
                        element={
                          <MuiTable navigate={navigate} />
                        }
                      /> */}
                            </ApproveCarrierFile>
                          }
                        />
                        <Route
                          path="/dentalplansetup"
                          element={<DentalPlanSetup navigate={navigate} />}
                        />
                        <Route
                          path="/visionplansetup"
                          element={<VisionPlanSetup navigate={navigate} />}
                        />
                        <Route
                          path="/importcarrierfile"
                          element={<ImportCarrierFile navigate={navigate} />}
                        />
                        <Route
                          path="/rebatesandreimbursements"
                          element={
                            <RebatesAndReimbursements navigate={navigate} />
                          }
                        />
                      </>
                    ) : location.pathname.match("servicerequest") ? (
                      <>
                        <Route
                          index
                          element={<ServiceRequest navigate={navigate} />}
                        />
                        <Route
                          path="/regionrequest"
                          element={<ServiceRequest navigate={navigate} />}
                        />
                        <Route
                          path="/SBARrequest"
                          element={<SBARFormRequest navigate={navigate} />}
                        />
                        <Route
                          path="/SBARIntakerequest"
                          element={<SBARFormIntakeRequest navigate={navigate} />}
                        />
                        <Route
                          path="/EmpoweRxRequest"
                          element={<EmpoweRxRequest navigate={navigate} />}
                        />
                        <Route
                          path="/ClinicalSupport"
                          element={<ClinicalSupport navigate={navigate} />}
                        />
                        <Route
                          path="/MarketScanMgmtRequest"
                          element={<MarketScanManagement navigate={navigate} />}
                        />
                      </>
                    ) : location.pathname.match("clinicalIntake") ? (
                      <>
                        <Route
                          index
                          element={user?.UserRole==="Clinician" || user?.UserRole==="Admin" ? <SBARIntakeRequest navigate={navigate} />:<SBARForm navigate={navigate} />}
                        />
                        <Route
                          path="/SBARIntakeRequest"
                          element={<SBARIntakeRequest navigate={navigate} />}
                        />
                        <Route
                          path="/SBAR"
                          element={<SBARForm navigate={navigate} />}
                        />
                        <Route
                          path="/SBARList"
                          element={<SBARFormReview navigate={navigate} />}
                        />
                        
                      </>
                    ) : location.pathname.match("ACGHealthInsights") ? (
                      <Route
                        path="/*"
                        element={<Dashboard navigate={navigate} />}
                      />
                    ) : location.pathname.match("EmpoweRx") ? (
                      <>
                        <Route
                          index
                          element={user?.UserRole !=="Client" ? <ClientRxInformation navigate={navigate} /> : <RxBlockPricingEx navigate={navigate} />}
                          />
                        <Route path="/EmpoweRxRFP/*">
                            <Route index element={<ClientRxInformation navigate={navigate} />} />
                            <Route path="ClientRxInformationBaseline" element={<ClientRxInformation navigate={navigate} />} />
                            <Route path="SDL" element={<SpecialtyDrugList navigate={navigate} />} />
                            <Route path="RFP" element={<EmpoweRX navigate={navigate} />} />
                        </Route>
                        <Route path="/RxBlockPricingEx" element={<RxBlockPricingEx navigate={navigate} />} />
                        <Route path="/RxBlockPricing/*">
                            <Route index element={<ReviewBlockPricing navigate={navigate} />} />
                            <Route path="ReviewBlockPricing" element={<ReviewBlockPricing navigate={navigate} />} />
                            <Route path="OpenUpdatePeriod" element={<OpenUpdatePeriod navigate={navigate} />} />
                        </Route>
                      </>
                    ) : location.pathname.match("planinsightsadmin") ? (
                      <>
                        <Route
                          index
                          element={<ListOfCDTGroup navigate={navigate} />}
                        />
                        <Route
                          path="/grouplist"
                          element={<ListOfCDTGroup navigate={navigate} />}
                        />
                      </>
                    ) : null}
                  </Routes>
                </div>
              </>
            }
          />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
